export const APPLICATION_ID = '72bfcee1-6dc2-4fec-891f-09bb18b50b4f'
export const CLIENT_TOKEN = 'pub26a02a06b48fbf4e291514a86a440c89'
export const SITE = 'datadoghq.eu'
export const SERVICE = 'web-frontdesk'
